import * as React from 'react';
import { useSegmentation } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';
import { Modal, ModalProps } from './Modal';

export const ModalWithOverrides: React.FC<ModalProps> = (props) => {
	const { segmentationId } = useSegmentation();
	const { data: translations } = useGetTranslations(segmentationId);

	return (
		<Modal
			{...props}
			translations={
				translations?.data === undefined
					? undefined
					: {
							close: translations?.data.shared.close ?? 'Close',
						}
			}
		/>
	);
};
